module.exports = __webpack_public_path__ + "img/xls.0d90b20c.png";